import React, {Component} from 'react';
// import $ from 'jquery';

class Dashboard extends Component {
    render() {
        return (
            'hello from dashboard'
        );
    }
}

export default Dashboard;



// WEBPACK FOOTER //
// ./src/components/Dashboard.js